import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, setJobSchedule } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSetJobScheduleApi = createAsyncThunk(
  "hitSetJobScheduleApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
      };
      const url = ApiBaseUrl + setJobSchedule;
      const response = await axios.put(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const SetJobScheduleSlice = createSlice({
  name: "setJobScheduleReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitSetJobScheduleData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSetJobScheduleApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSetJobScheduleApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSetJobScheduleApi.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearhitSetJobScheduleData } = SetJobScheduleSlice.actions;
export default SetJobScheduleSlice.reducer;
